import Checkbox from './theme/Inputs/Checkbox.vue'
import Radio from './theme/Inputs/Radio.vue'
import FormGroupInput from './theme/Inputs/formGroupInput.vue'
import Switch from './theme/Switch.vue'
import Progress from './theme/Progress.vue'

import DropDown from './theme/Dropdown.vue'
import Table from './theme/Table.vue'

import FadeRenderTransition from './theme/Transitions/FadeRenderTransition.vue'

import Card from './theme/Cards/Card.vue'
import ChartCard from './theme/Cards/ChartCard.vue'
import StatsCard from './theme/Cards/StatsCard.vue'

import Breadcrumb from './theme/Breadcrumb/Breadcrumb.vue'
import BreadcrumbItem from './theme/Breadcrumb/BreadcrumbItem.vue'

import Pagination from './theme/Pagination.vue'

import SidebarPlugin from './theme/SidebarPlugin'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

let components = {
  Checkbox,
  Switch,
  Progress,
  Pagination,
  Radio,
  FormGroupInput,
  Card,
  ChartCard,
  StatsCard,
  Table,
  DropDown,
  SidebarPlugin,
  FadeRenderTransition,
  Breadcrumb,
  BreadcrumbItem,
  VueTimepicker
}
export {
  Checkbox,
  Switch,
  Progress,
  Pagination,
  Radio,
  FormGroupInput,
  Card,
  ChartCard,
  StatsCard,
  Table,
  DropDown,
  SidebarPlugin,
  FadeRenderTransition,
  Breadcrumb,
  BreadcrumbItem,
  VueTimepicker
}

export default components



// WEBPACK FOOTER //
// ./src/components/index.js